/**
 * Get users browser language settings
 */
const preferredLangs: string[] = navigator.languages
  ? [...navigator.languages]
  : [navigator.language];

export default preferredLangs;
